<template>
    <div class="filters-wrap">
        <div class="dropdowns-wrap">
            <div>
                <label class="font-4 title">
                    Apps
                    <Disclaimer
                            class="app-disclaimer"
                            v-if="showDisclaimer"
                            :text="disclaimerText"
                            :uniqueId="disclaimerKey"
                            title="Consider filtering an app"></Disclaimer>
                </label>
                <Dropdown
                        :uniqueId="`${reportID}Apps`"
                        :options="apps"
                        :defaultText="`All Apps (${apps.length})`"
                        :selectedIds="selectedApps"
                        :enableIncludeExclude="true"
                        :isInclude="isIncludeApps"
                        :isMultipleSelection="true"
                        :isDisable="appsLoading"
                        :searchFields="['displayText', 'appKey', 'platform']"
                        markSelected
                        @selectionChanged="selectionChanged({
                            field: 'selectedApps',
                            value: $event.selected,
                            isIncludeField: 'isIncludeApps',
                            isIncludeMode: $event.isIncludeMode
                        })"
                        footerPadding
                        actionsWrapPadding>
                    <template slot="preOption" slot-scope="slotData">
                        <img :src="slotData.option.icon"
                             class="app-icon"
                             alt="" height="21" width="21">
                        <IconBase :iconName="slotData.option.platform.toLowerCase() + 'Icon'"
                                  width="12" height="12"
                                  class="platform-icon"
                                  key="platform"
                                  :iconColor="consts.COLORS.LIGHT_800">
                        </IconBase>
                    </template>
                    <template slot="postOption" slot-scope="slotData">
                        <IconBase :iconName="getAbIcon(slotData)"
                                  v-if="getAbIcon(slotData)"
                                  width="24" height="14"
                                  class="ab-icon"
                                  :key="getAbIcon(slotData)"
                                  :iconColor="consts.COLORS.LIGHT_700">
                        </IconBase>
                    </template>
                </Dropdown>
                <SelectionTags :options="selectedAppsTags" :uniqueId="`${reportID}Apps`"
                               v-if="apps.length"
                               @removeItem="removeSelection({
                                    field: 'selectedApps',
                                    selectedItems: selectedApps,
                                    item: $event,
                                    isIncludeField: 'isIncludeApps',
                                    isIncludeMode: isIncludeApps
                               })"
                ></SelectionTags>
            </div>
            <div>
                <label class="font-4 title">Countries</label>
                <Dropdown
                        :uniqueId="`${reportID}Countries`"
                        :options="countries"
                        :defaultText="`All Countries (${countriesLength})`"
                        :selectedIds="selectedCountries"
                        :enableIncludeExclude="true"
                        :isInclude="isIncludeCountries"
                        :isMultipleSelection="true"
                        :isDisable="countriesLoading"
                        markSelected
                        @selectionChanged="selectionChanged({
                            field: 'selectedCountries',
                            value: $event.selected,
                            isIncludeField: 'isIncludeCountries',
                            isIncludeMode: $event.isIncludeMode
                        })"
                        footerPadding
                        actionsWrapPadding>
                    <template slot="preOption" slot-scope="slotData">
                        <CountryFlag :countryCode="slotData.option.flag.toLowerCase()"
                                     class="country-icon"
                        ></CountryFlag>
                    </template>
                </Dropdown>
                <SelectionTags :options="selectedCountriesTags" :uniqueId="`${reportID}Countries`"
                               v-if="countries.length"
                               @removeItem="removeSelection({
                                    field: 'selectedCountries',
                                    selectedItems: selectedCountries,
                                    item: $event,
                                    isIncludeField: 'isIncludeCountries',
                                    isIncludeMode: isIncludeCountries
                               })"
                ></SelectionTags>
            </div>
            <div>
                <label class="font-4 title">Ad Sources</label>
                <Dropdown
                        :uniqueId="`${reportID}AdSources`"
                        :options="adSources"
                        :defaultText="`All Ad Sources (${adSources.length})`"
                        :selectedIds="selectedAdSources"
                        :enableIncludeExclude="true"
                        :isInclude="isIncludeAdSources"
                        :isMultipleSelection="true"
                        :isDisable="adSourcesLoading"
                        markSelected
                        @selectionChanged="selectionChanged({
                            field: 'selectedAdSources',
                            value: $event.selected,
                            isIncludeField: 'isIncludeAdSources',
                            isIncludeMode: $event.isIncludeMode
                        })"
                        footerPadding
                        actionsWrapPadding>
                </Dropdown>
                <SelectionTags :options="selectedAdSourcesTags" :uniqueId="`${reportID}AdSources`"
                               v-if="adSources.length"
                               @removeItem="removeSelection({
                                    field: 'selectedAdSources',
                                    selectedItems: selectedAdSources,
                                    item: $event,
                                    isIncludeField: 'isIncludeAdSources',
                                    isIncludeMode: isIncludeAdSources
                               })"
                ></SelectionTags>
            </div>
            <div>
                <label class="font-4 title">A/B</label>
                <Dropdown
                        :uniqueId="`${reportID}AB`"
                        :options="consts.AB_OBJ"
                        defaultText="All"
                        :selectedId="selectedABId"
                        markSelected
                        @dropdownSelectedItemChanged="abChanged"
                ></Dropdown>
            </div>
        </div>
        <IconBase iconName="separatorIcon" :iconColor="consts.COLORS.LIGHT_800"
                  height="16" width="4" class="separator"
        ></IconBase>
        <div>
            <label class="font-4 title">Date Range</label>
            <DateRange :range="dateRange"
                       :datePresetList="datePresetList"
                       :allowedDays="allowedDays"
                       :uniqueId="`${reportID}DateRange`"
                       @dateRangePresetNameChanged="$emit('dateRangePresetNameChanged', $event)"
                       @rangeChanged="$emit('filterChanged', { field: 'dateRange', value: $event })"
            ></DateRange>
        </div>
    </div>
</template>

<script>
import Dropdown from 'components/dropdowns/Dropdown.vue';
import DateRange from 'components/dateRange/DateRange.vue';
import IconBase from 'components/IconBase.vue';
import CountryFlag from 'components/countryFlag/countryFlag.vue';
import consts from 'services/metaData/consts';
import SelectionTags from 'components/selectedTags/SelectionTags.vue';
import Disclaimer from 'components/disclaimer/Disclaimer.vue';
import filtersMapping from 'monetize/reports/utils/filtersMapping';
import { mapGetters, mapActions } from 'vuex';
import { adUnitIds } from 'services/utils/adUnitsMap';

export default {
    name: 'Filters',
    components: {
        Disclaimer,
        SelectionTags,
        CountryFlag,
        IconBase,
        DateRange,
        Dropdown
    },
    props: {
        selectedApps: Array,
        selectedCountries: Array,
        selectedAdSources: Array,
        selectedAB: String,
        selectedAdUnit: String,
        isIncludeApps: Boolean,
        isIncludeCountries: Boolean,
        isIncludeAdSources: Boolean,
        dateRange: Object,
        companyId: Number,
        selectedBreak: String,
        allowDisclaimer: Boolean,
        reportID: String,
        datePresetList: {
            type: String,
            default: 'date'
        },
        allowedDays: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            consts,
            adSources: []
        };
    },
    computed: {
        ...mapGetters({
            providers: 'providers/getProviders',
            adSourcesLoading: 'providers/getAdSourcesLoading',
            mediationApplications: 'mediationApplications/getMediationApplications',
            appsLoading: 'mediationApplications/getAppsLoading',
            countriesState: 'countries/getCountriesState',
            countriesLoading: 'countries/getCountriesLoading'
        }),
        adSourcesMap() {
            if (!this.providers) return {};

            return this.providers.map;
        },
        apps() {
            if (!this.mediationApplications) return [];

            return Object.values(this.appsMap).map((app) => ({
                id: app.appKey,
                displayText: app.appName,
                ...app
            }));
        },
        appsMap() {
            if (!this.mediationApplications) return {};

            return this.mediationApplications.map;
        },
        countries() {
            if (!this.countriesState) return [];

            return this.countriesState;
        },
        countriesLength() {
            return this.countries.filter((country) => !country.isHeader).length;
        },
        countriesMap() {
            return this.countries.reduce((acc, country) => ({
                ...acc,
                [country.id]: country
            }), {});
        },
        selectedABId() {
            const ab = (consts.AB_OBJ.find((val) => val.key === this.selectedAB));
            return ab ? ab.id : 1;
        },
        selectedAppsTags() {
            return this.selectedApps.map((appKey) => ({
                key: appKey,
                text: this.appsMap[appKey] && this.appsMap[appKey].appName,
                icon: this.appsMap[appKey] ? {
                    name: `${this.appsMap[appKey].platform.toLowerCase()}Icon`,
                    color: consts.COLORS.LIGHT_800
                } : undefined
            }));
        },
        selectedAdSourcesTags() {
            return this.selectedAdSources.map((providerId) => ({
                key: providerId,
                text: this.adSourcesMap[providerId] && this.adSourcesMap[providerId].displayName
            }));
        },
        selectedCountriesTags() {
            return this.selectedCountries.map(
                (countryCode) => ({
                    key: countryCode,
                    text: this.countriesMap[countryCode] && this.countriesMap[countryCode].displayText,
                    flag: this.countriesMap[countryCode] && this.countriesMap[countryCode].flag.toLowerCase()
                })
            );
        },
        showDisclaimer() {
            return (this.selectedBreak === 'instances' || this.selectedBreak === 'placement')
                && this.selectedApps.length === 0 && this.allowDisclaimer;
        },
        disclaimerText() {
            if (this.selectedBreak === 'instances') {
                return `Current view shows instances across all your apps.
                    Consider filtering a single app to compare between its instances.`;
            }
            if (this.selectedBreak === 'placement') {
                return `Current view shows placements across all your apps.
                    Consider filtering a single app to compare between its placements.`;
            }
            return '';
        },
        disclaimerKey() {
            if (this.selectedBreak === 'instances') {
                return 'instancesBreakAppFilter';
            }
            if (this.selectedBreak === 'placement') {
                return 'placementBreakAppFilter';
            }
            return null;
        }
    },
    methods: {
        ...mapActions({
            fetchProviders: 'providers/fetch',
            fetchApps: 'mediationApplications/fetch',
            fetchCountries: 'countries/fetch'
        }),
        selectionChanged({
            field,
            value,
            isIncludeField,
            isIncludeMode
        }) {
            const valueParam = value.map((item) => item.id);
            this.$emit('filterChanged', {
                field,
                value: valueParam,
                isIncludeField,
                isIncludeMode
            });

            if (this.showDisclaimer) {
                this.$refs.appsDisclaimer.show();
            }
        },
        abChanged(abSelectionItem) {
            this.$emit('filterChanged', { field: 'selectedAB', value: abSelectionItem.key });
        },
        removeSelection({
            field,
            selectedItems,
            item,
            isIncludeField,
            isIncludeMode
        }) {
            const value = selectedItems.filter((selectedItem) => selectedItem !== item.key);

            this.$emit('filterChanged', {
                field,
                value,
                isIncludeField,
                isIncludeMode
            });
        },
        resetAdSourcesFilter() {
            if (this.providers) {
                this.adSources = this.providers.arr.map((provider) => ({
                    displayText: provider.displayName,
                    ...provider
                }));

                // update the adSources dropdown list
                if (this.selectedAdUnit !== adUnitIds.all) {
                    this.adSources = this.adSources.filter((adSource) => adSource.availableAdUnit
                        .includes(this.selectedAdUnit));
                }

                this.adSources.sort((a, b) => (a.displayName < b.displayName ? -1 : 1));
                const selectedAdSources = this.selectedAdSources
                    .filter((adSourceId) => this.adSources.find((item) => item.id === adSourceId));
                if (selectedAdSources.length !== this.selectedAdSources.length) {
                    this.$emit('filterChanged', {
                        field: 'selectedAdSources',
                        value: selectedAdSources
                    });
                }
            }
        },
        getAbIcon(dropdownSlotData) {
            if (!dropdownSlotData || !dropdownSlotData.option) {
                return null;
            }
            if (dropdownSlotData.option.hasAB) {
                return 'abIcon';
            }
            if (dropdownSlotData.option.hasQuickAB || dropdownSlotData.option.hasBiddingTest) {
                return 'quickABIcon';
            }
            return null;
        }
    },
    async created() {
        try {
            const { appParams, providersParams } = filtersMapping[this.reportID];
            if (this.companyId) {
                appParams.companyId = this.companyId;
                providersParams.companyId = this.companyId;
            }
            this.fetchProviders({
                filters: providersParams
            });
            this.fetchApps({
                filters: appParams
            });
            this.fetchCountries();
        } catch (e) {
            this.errorMessage = (e && e.error) || consts.GENERAL_SERVICE_ERROR;
        }
    },
    watch: {
        providers: {
            handler() {
                this.resetAdSourcesFilter();
            },
            immediate: true
        },
        selectedAdUnit() {
            this.resetAdSourcesFilter();
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.scss";

.filters-wrap {
    display: grid;
    grid-template-columns: 3fr 4px 1fr;
    grid-column-gap: 8px;
    padding: 10px 10px 1px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    background-color: $white;
    border-bottom: $border;
}

.dropdowns-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 10px;
}

.separator {
    margin-top: 28px;
}

.title {
    padding-bottom: 3px;
    display: block;
}

.app-icon, .country-icon {
    vertical-align: middle;
    margin-left: 7px;
    margin-right: 7px;
}

.platform-icon {
    margin-left: -2px;
    vertical-align: middle;
    margin-right: 5px;
    height: 12px;
}

.ab-icon {
    vertical-align: middle;
    position: absolute;
    top: 14px;
    right: 1px;
}

.app-disclaimer {
    display: inline-block;
}
</style>
